import AxiosError from '../core/AxiosError.js';
import utils from '../utils.js';

function CanceledError(message,config,request){AxiosError.call(this,message==null?"canceled":message,AxiosError.ERR_CANCELED,config,request);this.name="CanceledError";}utils.inherits(CanceledError,AxiosError,{__CANCEL__:true});

export { CanceledError as default };
//# sourceMappingURL=CanceledError.js.map
